import React, { Suspense, useState, useEffect, useRef } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import CardLayout from './Components/CardLayout';
import CardBody from './Components/CardBody';
import CreateFormContent from './Section/CreateFormContent';
import GlobalCustomButton from 'modules/Common/Components/GlobalCustomButton';
import AddIcon from 'assets/svgs/AddIcon';
import CreateFormMapping from './Section/CreateFormMapping';
import FormSubmission from './Section/FormSubmission';
import CreateFormFooter from './Components/CreateFormFooter';
import { IActionData, IFieldDataTemp, IUpdateAction } from './interfaces';
import { useHistory } from 'react-router-dom';
import { createNewForm, getFormDetailsAction, updateForm } from './actions';
import { getCampaignsNamesOnly, resetCampaignsNamesOnly } from 'modules/Campaigns/CampaignAssets/actions';
import { useSelector } from 'react-redux';
import store, { RootState } from 'store';
import { ICampaignsName } from 'modules/Campaigns/interfaces';
import { AUDIENCE_LISTS } from 'constants/types';
import { getListNames } from 'modules/Audience/Actions/listsActions';
import { createNewListInWorkflowService } from 'modules/Services/AudienceService';
import { getQueryFormId } from 'modules/EmailBrowser/utils';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import { message } from 'antd';
import { internalFieldMappings } from './constants';
import { Skeleton } from 'antd';
import CreateFormSkeleton from './Components/CreateFormSkeletons';
const { Text } = Typography;

const Wrapper = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding-bottom: 8em;
  #create-form-scroller {
    /* overflow-y: auto;
    overflow-x: hidden;
    height: 62vh;
    max-height: 100vh; */
  }
  #form-submission-card .checked-wrap {
    color: #1ec252 !important;
    font-family: 'Roboto' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 19px !important; /* 118.75% */
    letter-spacing: -0.4px !important;
    @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px !important;
    }
  }
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 14px;
    margin-top: 15px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #001760;
    border-radius: 14px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #001760;
  }
  #form-submission-card .css-c3py3x-singleValue {
    color: #7e7e7e !important;
    font-family: 'Roboto' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 20px !important;
    @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px !important;
    }
  }
  #deleteIcon {
    margin-left: 12px;
    cursor: pointer;
  }
  .add-list {
    /* padding: 0 12px 0 0; */
    .css-vqtttq-ValueContainer {
      padding: 0;
    }
    .css-1uxsi1k-menu {
      z-index: 6;
      min-width: auto !important;
    }
    > div {
      z-index: unset;
      > div {
        min-height: 38px;
        width: 191px;
        border-radius: 8px;
        @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
          width: 130px !important;
        }
      }
    }
  }
  .vertical-divider {
    margin: 0 6px;
  }
  .delete-icon {
    width: 11.46px;
    height: 11.46px;
  }
  #delete-mask-icon {
    cursor: pointer;
    margin-left: 12px;
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 8px !important;
    }
  }
`;

const Title = styled.div`
  color: #424b50;
  font-size: 26px;
  font-family: 'Roboto Slab';
  font-weight: 700;
  line-height: 39px;
  .text-ellipse {
    color: #424b50;
    font-size: 26px;
    font-family: 'Roboto Slab';
    font-weight: 700;
    line-height: 39px;
    letter-spacing: -0.65px;
    font-style: normal;
  }
`;

const InputTitle = styled.h2`
  color: #424b50;
  font-family: 'Roboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.5px;
  white-space: nowrap;
  margin: 0;
  @media all and (max-width: 1439px) {
    font-size: 16px !important;
  }
`;

const LayoutSection = styled.div`
  // height: 460px;
  // overflow: auto;
  // @media all and (-webkit-device-pixel-ratio: 1) {
  //   height: 630px;
  // }
`;

const DialogWrapper = styled.div`
  .setting-delete-dialog {
    width: 326px !important;
    .message {
      font-family: 'Roboto Slab' !important;
      font-weight: 700 !important;
      line-height: 26px !important;
      font-size: 20px !important;
    }
    .message-footer {
      margin: 24px 20px 10px 20px !important;
    }
    img {
      margin: 17px 0 10px 0px !important;
    }
  }
  .message-footer a {
    font-family: 'Roboto' !important;
    line-height: 20px !important;
    font-weight: 700 !important;
  }
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

const CreateFormHandler: React.FC = () => {
  // Redux States
  const campaignItems = useSelector((state: RootState) => state.getCampaignNames.data);
  const campaignItemsLoading = useSelector((state: RootState) => state.getCampaignNames.loading);
  const campaignSearchTerm = useSelector((state: RootState) => state.getCampaignNames.searchTerm);
  const listDataNames = useSelector((state: RootState) => state.audienceListsReducerV2.listsDataNames);
  const listDataNamesLoading = useSelector((state: RootState) => state.audienceListsReducerV2.listsDataNamesLoading);
  const selectedFormLoading = useSelector((state: RootState) => state.forms.selectedForm.loading);
  const selectedFormName = useSelector((state: RootState) => state.forms.selectedForm.data.name);
  const selectedFormCampaignId = useSelector((state: RootState) => state.forms.selectedForm.data.campaignId);
  const selectedFormCampaignName = useSelector((state: RootState) => state.forms.selectedForm.data.campaignName);
  const selectedFormActions = useSelector((state: RootState) => state.forms.selectedForm.data.actions);
  const selectedFormFields = useSelector((state: RootState) => state.forms.selectedForm.data.fields);
  const totalForms = useSelector((state: RootState) => state.forms.forms.totalCount);

  // Local Variables
  const history = useHistory();
  const popupDeleteMessage = 'Are you sure you want to delete?';
  const formId = getQueryFormId();

  // Local States
  const [formName, setFormName] = useState(formId ? selectedFormName : '');
  const [linkedCampaign, setLinkedCampaign] = useState(formId ? { id: selectedFormCampaignId, name: selectedFormCampaignName } : { id: 0, name: '' });
  const [formActions, setFormActions] = useState<IActionData[]>([]);
  const [updateFormActions, setUpdateFormActions] = useState<IUpdateAction>({ create: [], update: [], delete: [] });
  const [formFieldMappings, setFormFieldMappings] = useState<IFieldDataTemp[]>([]);
  const [disableAddField, setDisableAddField] = useState(false);
  const [disableCreateFormButton, setDisableCreateFormButton] = useState(true);
  const [isOpenDeletePopup, setisOpenDeletePopup] = useState(false);
  const [hasClickedCreate, setHasClickedCreate] = useState(false);
  const [isDisableOnFieldChanged, setIsDisableOnFieldChanged] = useState(false);
  const [tempObj, setTempObj] = useState<{ index: number; isAction?: boolean; action?: IActionData }>({ index: -1 });
  const [firstTimeForUpdateButton, setFirstTimeForUpdateButton] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);
  const [newListAdded, setNewListAdded] = useState(false);
  const [newListActionIndex, setNewListActionIndex] = useState(-1);

  // useRefs
  const fieldsRef = useRef<HTMLDivElement>(null);

  // ||------ FUNCTIONS ------||
  // Campaign Dropdown
  const handleSearchCampaign = (searchTerm: string) => {
    resetCampaignsNamesOnly();
    getCampaignsNamesOnly({ offset: 0, limit: 20, search_campaign: searchTerm });
  };

  const campaignsLoadMore = (campaigns: ICampaignsName[]) => {
    if (!campaignItemsLoading) getCampaignsNamesOnly({ offset: campaigns?.length, limit: 20, search_campaign: campaignSearchTerm });
  };

  // FORM ACTIONS
  const onAddAction = () => {
    setFormActions([...formActions, { 'Add to list': '' }]);
  };

  const deleteActionHandler = (index: number, action: IActionData) => {
    const updatedFormActions = formActions.filter((current, actionIndex) => actionIndex !== index);
    setFormActions(updatedFormActions);
    if ('id' in action) setUpdateFormActions({ ...updateFormActions, delete: [...updateFormActions.delete, Number(action['id'])] });
  };

  const onChangeActionType = (index: number, newKey: string) => {
    const updatedFormActions = [...formActions];
    const tempAction = formActions[index];
    const key = Object.keys(tempAction)[0];
    const newObj = { [newKey]: tempAction[key] };
    delete tempAction[key];
    updatedFormActions[index] = {
      ...newObj,
      ...tempAction,
    };
    setFormActions(updatedFormActions);
  };

  const onChangeListCheckbox = (checked: boolean, index: number, listId: number, listName: string, action: IActionData) => {
    const tempFormActions = [...formActions];
    const tempAction = tempFormActions[index];
    const key = Object.keys(tempAction)[0];
    const value = Object.values(tempAction)[0]?.toString();
    const listNameValue = tempAction['list_names']?.toString();
    const listIds = value?.split(',');
    const listNames = listNameValue?.split(',');
    if (checked) {
      // Add list id and name
      if (value?.length === 0) tempAction[key] = listId.toString();
      else {
        listIds.push(listId.toString());
        const listIdsString = listIds.join();
        tempAction[key] = listIdsString;
      }
      if ('list_names' in tempAction) {
        listNames.push(listName);
        const listNamesString = listNames.join();
        tempAction['list_names'] = listNamesString;
      } else tempAction['list_names'] = listName;
    } else {
      // Remove list id and name
      const updatedListIds = listIds?.filter((id) => id !== listId.toString());
      const listIdsString = updatedListIds?.join();
      tempAction[key] = listIdsString;
      if (listNames?.length > 1) {
        const updatedListNames = listNames?.filter((l_name: string) => l_name !== listName);
        const listNamesString = updatedListNames?.join();
        tempAction['list_names'] = listNamesString;
      } else delete tempAction['list_names'];
    }
    tempFormActions[index] = {
      ...tempAction,
    };
    setFormActions(tempFormActions);
    // add updated action for update_form API payload
    if (key !== 'Select Action' && value !== '') {
      if ('id' in action) {
        let flag: boolean = false,
          ind: number = 0;
        updateFormActions.update.forEach((a, index) => {
          if (a['id'] === action['id']) {
            flag = true;
            ind = index;
          }
        });
        if (flag) {
          // if id already exists in updated actions
          const tempActions = [...updateFormActions.update];
          tempActions[ind] = { ...action };
          setUpdateFormActions({ ...updateFormActions, update: [...tempActions] });
        } else setUpdateFormActions({ ...updateFormActions, update: [...updateFormActions.update, action] });
      }
    }
  };

  const onClickCreateList = (listName: string) => {
    createNewListInWorkflowService(listName).then((res) => {
      if (res.data.success) {
        // Success toaster
        message.success({
          content: `List has been created successfully.`,
        });
        store.dispatch({ type: AUDIENCE_LISTS.NAMES_RESET });
        getListNames();
      } else {
        message.error(res.data.message);
      }
    });
  };

  // FORM FIELDS
  const onAddField = () => {
    fieldsRef?.current && fieldsRef?.current.scrollIntoView();
    setFormFieldMappings([
      ...formFieldMappings,
      { externalField: '', internalField: 'First Name', dataFormat: 'Text', isRequired: true, isSaved: false },
    ]);
    setDisableAddField(true);
  };

  const deleteFieldMappingHandler = (index: number) => {
    const updatedFieldMappings = formFieldMappings.filter((current, fieldIndex) => fieldIndex !== index);
    setFormFieldMappings(updatedFieldMappings);
  };

  const onChangeFieldValue = (value: boolean | string, index: number, keyName: keyof IFieldDataTemp) => {
    const updatedFieldMappings = [...formFieldMappings];
    const tempFieldMapping = formFieldMappings[index];
    updatedFieldMappings[index] = {
      ...tempFieldMapping,
      [keyName]: value,
    };
    setFormFieldMappings(updatedFieldMappings);
    // anything changed check update (Save button enables)
    if (isDisableOnFieldChanged) setIsDisableOnFieldChanged(false);
  };

  const checkCreateFormButton = () => {
    let isDisable = false;
    if (formName?.trim()?.length === 0) isDisable = true;
    if (formFieldMappings?.length === 0) isDisable = true;
    formFieldMappings.forEach((fieldMapping) => {
      if (fieldMapping.isSaved !== true) isDisable = true;
    });
    setDisableCreateFormButton(isDisable);
  };

  const fieldsTypeChanger = () => {
    const formArray = Object.assign([], selectedFormFields);
    const tempFormFields: IFieldDataTemp[] = formArray.map((field: any) => {
      return {
        externalField: field.external_field,
        internalField: field.internal_field,
        dataFormat: field.data_type,
        isRequired: field.is_required,
        isSaved: field.is_saved,
      };
    });
    setFormFieldMappings(tempFormFields);
  };

  const setDefaultFieldValue = (index: number, field: IFieldDataTemp) => {
    const tempFields: IFieldDataTemp[] = [...formFieldMappings];
    tempFields[index] = field;
    setFormFieldMappings([...tempFields]);
  };

  // FORM FOOTER
  const onClickCreateFormButton = () => {
    // Getting Form Fields into required format for payload
    const tempFormFields = formFieldMappings.map((field) => ({
      external_field: field.externalField,
      internal_field: internalFieldMappings[field.internalField as keyof typeof internalFieldMappings],
      data_type: field.dataFormat,
      is_required: field.isRequired,
      is_saved: field.isSaved,
    }));
    // Getting Form Actions into required format for payload
    const tempFormActions = [...formActions];
    const actionsToBeOmitted: number[] = [];
    const newActions = [...updateFormActions.create];
    const deleteActions = [...updateFormActions.delete];
    const updateActionsTemp = [...updateFormActions.update];
    tempFormActions.forEach((action, index) => {
      const key = Object.keys(action)[0];
      const value = Object.values(action)[0].toString();
      if (key === 'Add to list') {
        const newObj = { ['atl']: action[key] };
        delete action[key];
        tempFormActions[index] = {
          ...newObj,
          ...action,
        };
      }
      if (!('id' in action)) newActions.push(tempFormActions[index]);
      if (key === 'Select Action' || value === '') {
        actionsToBeOmitted.push(index);
        if ('id' in action) deleteActions.push(Number(action['id']));
      }
    });
    const onEditActions = { create: [...newActions], update: [...updateActionsTemp], delete: [...deleteActions] };
    const requiredFormActions = tempFormActions.filter((action, index) => !actionsToBeOmitted.includes(index));
    const requiredFormFields = Object.assign({}, tempFormFields);
    if (formId) {
      // ON EDIT FORM
      // convert 'Add to list' to 'atl' of create
      let indicesToBeRemovedOfCreate: number[] = [],
        indicesToBeRemovedOfUpdate: number[] = [];
      if (onEditActions.create?.length > 0) {
        onEditActions.create.forEach((c_action, index) => {
          const value = Object.values(c_action)[0];
          if (value === '') {
            indicesToBeRemovedOfCreate.push(index);
          }
        });
      }
      // convert 'Add to list' to 'atl' of update
      if (onEditActions.update?.length > 0) {
        onEditActions.update.forEach((u_action, index) => {
          const key = Object.keys(u_action)[0];
          const value = Object.values(u_action)[0];
          if (key === 'Add to list' && value?.toString()?.length > 0) {
            const newObj = { ['atl']: u_action[key] };
            delete u_action[key];
            onEditActions.update[index] = {
              ...newObj,
              ...u_action,
            };
          } else {
            indicesToBeRemovedOfUpdate.push(index);
          }
        });
      }
      // Removing the action newly added with no action type or lists selected
      let newCreateActions = onEditActions.create.filter((ac, index) => !indicesToBeRemovedOfCreate.includes(index));
      // Removing the action updated with no action type or lists selected
      let newUpdateActions = onEditActions.update.filter((ac, index) => !indicesToBeRemovedOfUpdate.includes(index));
      // Final actions
      const finalActionsOnEdit = { create: [...newCreateActions], update: [...newUpdateActions], delete: [...onEditActions.delete] };
      if (!hasClickedCreate) {
        // for only single click
        setHasClickedCreate(true);
        // update_form API call
        updateForm(history, formId, formName?.trim(), finalActionsOnEdit, requiredFormFields, linkedCampaign?.id?.toString());
      }
    } else {
      // ON CREATE FORM
      if (!hasClickedCreate) {
        // for only single click
        setHasClickedCreate(true);
        // create_form API call
        createNewForm(history, formName?.trim(), requiredFormActions, requiredFormFields, linkedCampaign?.id?.toString());
        // Updating total forms count in local Storage
        localStorage.removeItem('totalForms');
        const count = totalForms + 1;
        localStorage.setItem('totalForms', count?.toString());
      }
    }
  };

  // useEffects
  useEffect(() => {
    if (formId) {
      // Get form details API call
      getFormDetailsAction(parseInt(formId));
      // Setting fields in the correct format on Edit Form
      fieldsTypeChanger();
      setFirstTimeForUpdateButton(true);
    }
  }, []);

  useEffect(() => {
    if (formId) {
      // Setting data
      setFormName(selectedFormName);
      setLinkedCampaign({ id: selectedFormCampaignId, name: selectedFormCampaignName });
      setFormActions(selectedFormActions);
      // Setting fields in the correct format on Edit Form
      fieldsTypeChanger();
    }
  }, [selectedFormName]);

  useEffect(() => {
    checkCreateFormButton();
    if (formId && firstTimeForUpdateButton) {
      // Disabling the Update button for the first time landing on Edit page
      setDisableCreateFormButton(true);
      // Setting first time check
      setFirstTimeForUpdateButton(false);
    }
  }, [formName, formFieldMappings]);

  useEffect(() => {
    if (formId && !firstTimeForUpdateButton) {
      setDisableCreateFormButton(false);
      checkCreateFormButton();
    }
  }, [formActions, linkedCampaign]);

  return (
    <>
      <Wrapper>
        {selectedFormLoading ? (
          <>
            <span>
              <Skeleton.Button
                style={{ width: '120px', height: '30px', display: 'flex', alignItems: 'center', borderRadius: '20px' }}
                active
                size={'small'}
                shape={'square'}
                block={true}
              />
            </span>
            <CreateFormSkeleton />
          </>
        ) : (
          <>
            <Title>
              {formId ? (
                <Text
                  style={ellipsis ? { width: 450 } : undefined}
                  className="text-ellipse"
                  ellipsis={
                    ellipsis
                      ? {
                          tooltip: selectedFormName,
                        }
                      : false
                  }
                >
                  {selectedFormName}
                </Text>
              ) : (
                'Create new Form Handler'
              )}
            </Title>
            <LayoutSection id="create-form-scroller">
              <CardLayout width="" maxWidth="" margin={'10px 0 0 0'}>
                <CardBody className={''} flexFlow={'column'} justifyContent={'space-between'} alignItems={''} customCSS={undefined}>
                  <CreateFormContent
                    formName={formName}
                    linkedCampaign={linkedCampaign}
                    setFormName={setFormName}
                    setLinkedCampaign={setLinkedCampaign}
                    handleSearchCampaign={handleSearchCampaign}
                    campaignsLoadMore={campaignsLoadMore}
                    campaignItems={campaignItems}
                    campaignItemsLoading={campaignItemsLoading}
                    campaignSearchTerm={campaignSearchTerm}
                  />
                </CardBody>
              </CardLayout>
              {/* Form Submission Action */}
              <CardLayout width="" maxWidth="" margin="16px 0 0 0">
                <CardBody className={''} flexFlow={'row'} justifyContent={'space-between'} alignItems={'center'} customCSS={undefined}>
                  <InputTitle>Form Submission Actions</InputTitle>
                  <GlobalCustomButton
                    btnText={'Add New Action'}
                    disabled={false}
                    onClick={onAddAction}
                    border={'none'}
                    padding={''}
                    bgColor={'#1EC252'}
                    color={'#fff'}
                    customIcon={<AddIcon />}
                    borderRadius={'6px'}
                    fontSize={'16px'}
                    boxShadow={''}
                  />
                </CardBody>
                {/* Add & Select List */}
                <div id="form-submission-card">
                  {formActions.map((action: IActionData, index: number) => (
                    <CardBody
                      key={index}
                      className={'select-list'}
                      customCSS={{ margin: '12px 0 0 0' }}
                      flexFlow={'row'}
                      justifyContent={'space-between'}
                      alignItems={'center'}
                    >
                      <FormSubmission
                        action={action}
                        actionIndex={index}
                        onChangeActionType={onChangeActionType}
                        onChangeCheckbox={onChangeListCheckbox}
                        listDataNames={listDataNames}
                        listDataNamesLoading={listDataNamesLoading}
                        onClickCreateList={onClickCreateList}
                        setisOpenDeletePopup={setisOpenDeletePopup}
                        setTempObj={setTempObj}
                        deleteActionHandler={deleteActionHandler}
                        newListAdded={newListAdded}
                        setNewListAdded={setNewListAdded}
                        newListActionIndex={newListActionIndex}
                        setNewListActionIndex={setNewListActionIndex}
                      />
                    </CardBody>
                  ))}
                </div>
              </CardLayout>
              {/* Form Field Mappings */}
              <CardLayout width="" maxWidth="" margin="16px 0 0 0">
                <CardBody className={''} flexFlow={'row'} justifyContent={'space-between'} alignItems={'center'} customCSS={undefined}>
                  <InputTitle>Form Fields Mapping*</InputTitle>
                  <GlobalCustomButton
                    btnText={'Add New Field'}
                    disabled={disableAddField}
                    onClick={onAddField}
                    border={'none'}
                    padding={''}
                    bgColor={'#1EC252'}
                    color={'#fff'}
                    customIcon={<AddIcon />}
                    borderRadius={'6px'}
                    fontSize={'16px'}
                    boxShadow={''}
                  />
                </CardBody>
                <div id="form-card-scroller">
                  {formFieldMappings.map((field: IFieldDataTemp, index: number) => (
                    <CardBody
                      key={index}
                      className={'select-list'}
                      customCSS={{ margin: '0' }}
                      flexFlow={'column'}
                      justifyContent={''}
                      alignItems={''}
                    >
                      <CreateFormMapping
                        field={field}
                        fieldIndex={index}
                        onChangeFieldValue={onChangeFieldValue}
                        deleteFieldMapping={deleteFieldMappingHandler}
                        disableAddField={disableAddField}
                        setDisableAddField={setDisableAddField}
                        checkCreateFormButton={checkCreateFormButton}
                        setisOpenDeletePopup={setisOpenDeletePopup}
                        setTempObj={setTempObj}
                        isDisableOnFieldChanged={isDisableOnFieldChanged}
                        setIsDisableOnFieldChanged={setIsDisableOnFieldChanged}
                        setDefaultFieldValue={setDefaultFieldValue}
                      />
                    </CardBody>
                  ))}
                </div>
                <div ref={fieldsRef}></div>
              </CardLayout>
            </LayoutSection>
          </>
        )}
      </Wrapper>
      <Suspense fallback={<></>}>
        <CreateFormFooter
          btnText={`${formId ? 'Update' : 'Create Form Handler'}`}
          disableButton={disableCreateFormButton || hasClickedCreate}
          onClick={() => onClickCreateFormButton()}
          footerType={'default'}
        />
      </Suspense>
      {isOpenDeletePopup ? (
        <DialogWrapper>
          <div className="back-overlay" />
          <ConfirmDialog
            className="setting-delete-dialog"
            cancel="Cancel"
            confirm={'Delete'}
            onConfirm={() => {
              if (tempObj.isAction) {
                message.success({
                  content: `The action has been deleted successfully.`,
                });
                tempObj.action && deleteActionHandler(tempObj.index, tempObj.action);
              } else {
                message.success({
                  content: `The field has been deleted successfully.`,
                });
                deleteFieldMappingHandler(tempObj.index);
              }
              setisOpenDeletePopup(false);
            }}
            onCancel={() => setisOpenDeletePopup(false)}
            title={popupDeleteMessage}
            titleQuestion={null}
          />
        </DialogWrapper>
      ) : null}
    </>
  );
};

export default CreateFormHandler;
